'use strict';

var ParticlShader = require('./materials/ParticleShader.js');

var BurstBubbleParticles = function(options){

  THREE.Object3D.call(this);

  this.count = 100;

  this.minRad = 3;

  this.maxRad = 40;

  this.burstTime = 500;

  // set custom attributes
  for(var i in options || {}){
    this[i] = options[i]
  }


  // this.material = 

  this.geometry = new THREE.Geometry();
  for(var i=0;i<this.count; i++){
    var v = new THREE.Vector3( Math.random(), Math.random(), Math.random() )
      .addScalar(-0.5)
      .normalize();

    this.geometry.vertices.push( v );
  }

  this.material = new ParticlShader();

};



BurstBubbleParticles.prototype = Object.create(THREE.Object3D.prototype);
BurstBubbleParticles.prototype.constructor = BurstBubbleParticles;



BurstBubbleParticles.prototype.pop = function(r, pos){
  
  // clone material
  var mat = this.material.clone();

  // animate material unforms
  mat.uniforms.radius.value = r * 0.05;
  new TWEEN.Tween(mat.uniforms.radius)
    .to({value: 0}, this.burstTime)
    .easing( TWEEN.Easing.Cubic.Out )
    .start();

  // create new points object
  var p = new THREE.Points(this.geometry, mat);
  p.position.copy(pos);
  p.scale.set(r,r,r);
  
  // animate points transforms
  var s = r * (Math.random() * 0.5 + 0.5);
  new TWEEN.Tween(p.scale)
    .to({x:s,y:s,z:s}, this.burstTime)
    .easing( TWEEN.Easing.Cubic.Out )
    .start();


  new TWEEN.Tween(p.position)
    .to({y:p.position.y - Math.random() * 10 - 10}, this.burstTime)
    .easing( TWEEN.Easing.Cubic.Out )
    .start();

  new TWEEN.Tween(p.rotation)
    .to({
      x: (Math.random() - 0.5) * 1.0,
      y: (Math.random() - 0.5) * 1.0,
      z:0}, this.burstTime)
    .easing( TWEEN.Easing.Cubic.Out )
    .start();

  // add to this
  this.add( p )

  // remove and destroy on timeout
  var scope = this;
  setTimeout(function(){

    scope.remove( this );
    
    this.material.dispose();

  }.bind(p), this.burstTime);

}

module.exports = BurstBubbleParticles;
  